import { Typography, IconButton } from '@mui/material';
import { Settings, Error } from '@mui/icons-material';

import { CardBottom, CardContent, CardBody } from '../style';

// TODO color these (and the settings icon) based on the image, make it contrasting
// and move this to style.ts
const cardText = {
  background: 'white',
  borderRadius: '20px',
  paddingLeft: '10px',
  paddingRight: '10px',
  margin: '5px',
  fontFamily: 'IBM Plex Sans Condensed',
  boxShadow: '0 2px 8px rgba(15, 15, 15, 0.6)',
};

function CardFront({ flip, card }) {
  return (
    <CardBody
      onClick={() => flip((prev) => !prev)}
      style={{
        backgroundImage: `url(${card.background.url})`,
        borderRadius: '8px',
      }}
    >
      <link
        href='https://fonts.googleapis.com/css?family=IBM Plex Sans Condensed'
        rel='stylesheet'
      ></link>
      <IconButton disabled={true} style={{ justifyContent: 'flex-start' }}>
        <Settings />
      </IconButton>

      {/* <Settings
        style={{
          color: 'white',
          boxShadow: '0 2px 8px rgba(15, 15, 15, 0.6)'

        }}
      /> */}
      {!card.subscription && (
        <Error
          style={{
            color: 'white',
          }}
        />
      )}
      <CardBottom>
        <CardContent>
          <Typography style={cardText}>
            {card.month}/{card.year}
          </Typography>
          <Typography style={cardText}>XXXX-XXXX-XXXX-{card.last4}</Typography>
        </CardContent>
        <CardContent>
          <Typography style={cardText}>{card.type}</Typography>
        </CardContent>
      </CardBottom>
    </CardBody>
  );
}

export default CardFront;
